import axiosInstance from "./axiosInstance";

export const getTopNavbar = async (locale = "en") => {

  const res = await axiosInstance.get(
    `/api/top-navbars?locale=${locale}`
  );

  return res.data.data[0];

};